// Test IDs for the home / landing feature.

export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const NAV = {
  logo: 'nav-logo',
  linkPackages: 'nav-link-packages',
  linkAddons: 'nav-link-addons',
  linkHow: 'nav-link-how-it-works',
  linkContact: 'nav-link-contact',
  ctaQuote: 'nav-cta-quote',
};

export const HERO = {
  section: 'hero-section',
  heading: 'hero-heading',
  subtitle: 'hero-subtitle',
  ctaCheck: 'hero-cta-check-availability',
  ctaPackages: 'hero-cta-view-packages',
};

export const PACKAGES = {
  section: 'packages-section',
  cardPetite: 'package-card-petite',
  cardSignature: 'package-card-signature',
  cardRoyal: 'package-card-royal',
  bookPetite: 'package-book-petite',
  bookSignature: 'package-book-signature',
  bookRoyal: 'package-book-royal',
};

export const ADDONS = {
  section: 'addons-section',
  item: (key) => `addon-item-${key}`,
};

export const STEPS = {
  section: 'steps-section',
  step: (n) => `step-${n}`,
};

export const QUOTE = {
  section: 'quote-section',
  form: 'quote-form',
  name: 'quote-input-name',
  email: 'quote-input-email',
  phone: 'quote-input-phone',
  date: 'quote-input-date',
  package: 'quote-select-package',
  message: 'quote-input-message',
  submit: 'quote-submit',
  success: 'quote-success-message',
  error: 'quote-error-message',
};

export const FOOTER = {
  section: 'footer-section',
};
